import ModelsIcon from '@/Theme/icons/modelsIcon';
import { icons as modelIcons } from '@/Theme/icons/modelsIcons/index';
import { UserCircleIcon } from '@heroicons/react/24/solid';
import { get } from 'lodash';

export const getIcon = (model, color = 'white') => {
  const Icon = get(modelIcons, model.icon);
  return Icon ? (
    <Icon
      className="h-[14px] w-[14px]"
      fillColor={model.color || '#464BBA'}
      color={color}
    />
  ) : (
    <ModelsIcon className="h-[14px] w-[14px] stroke-white" />
  );
};

export const getImageProfile = (item) => {
  return (
    <>
      {item.creator?.avatar?.svg ? (
        <div className="avatar">
          <div className="w-6 rounded">
            <div
              dangerouslySetInnerHTML={{
                __html: item.creator.avatar.svg,
              }}
            />
          </div>
        </div>
      ) : (
        <UserCircleIcon className="size-6 transition text-cool-gray dark:text-battleship-gray" />
      )}
    </>
  );
};
